import axios from 'axios';
import { getAuthHeaders } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const fetchHoroscope = async (placename, birthDate, birthTime, latitude = null, longitude = null, city = null, country = null, divisionalChartFactor = 1) => {
  try {
    // Ensure birth_time has seconds (HH:MM:SS format)
    const formattedTime = birthTime.includes(':') && birthTime.split(':').length === 2 
      ? `${birthTime}:00` 
      : birthTime;

    const payload = {
      placename,
      birth_date: birthDate,
      birth_time: formattedTime,
      divisional_chart_factor: divisionalChartFactor
    };

    // Add latitude and longitude if available
    if (latitude !== null && longitude !== null) {
      payload.latitude = latitude;
      payload.longitude = longitude;
    }

    // Add only city and country if available
    if (city) payload.city = city;
    if (country) payload.country = country;

    console.log('Sending horoscope request with payload:', payload);

    const response = await axios.post(`${API_BASE_URL}/horoscope`, payload, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching horoscope:', error);
    throw error;
  }
};
